export { default as host } from './host';
export { default as color } from './color';
export { default as media } from './media';
export { default as size } from './size';
export { default as toCurrency } from './toCurrency';
export { default as toPercentage } from './toPercentage';
export { default as getValue } from './getValue';
export { default as getDiscountValue } from './getDiscountValue';
export { default as getDiscountProps } from './getDiscountProps';
export { default as getLayer } from './getLayer';
export { default as getResult } from './getResult';
export { default as pattern } from './pattern';
export { default as mapState } from './mapState';
export { default as formatDiscount } from './formatDiscount';
export { default as createCancelToken } from './createCancelToken';



// WEBPACK FOOTER //
// ../pos-master/packages/pos-helper/src/index.js